import { bool } from 'prop-types'

export const CalendarPermissions = {
    canView: bool,
    canEdit: bool,
    canAdd: bool,
    canShare: bool
}